import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IStickySectionProps } from '../components/sticky-sections-wrapper/sticky-section/sticky-section';
import { IStickySectionsWrapperProps } from '../components/sticky-sections-wrapper/sticky-sections-wrapper';
import { StickySectionModel } from './sticky-section-model';

export class StickySectionsWrapperModel extends ContentItem {
  get image(): {
    url: string;
    description: string;
  } {
    return get(this._config, 'elements.sticky_image.value[0]', {});
  }

  get sections(): IStickySectionProps[] {
    const getSections = get(this._config, 'elements.sections.value', null);

    const transformSections = getSections
      ? getSections.map((section: IStickySection) =>
          StickySectionModel.create(section)
        )
      : null;
    return transformSections;
  }

  public static create(
    data: IStickySectionsWrapper
  ): IStickySectionsWrapperProps {
    const { sections, image } = new StickySectionsWrapperModel(data);
    return {
      sections,
      image
    };
  }
}
